// extracted by mini-css-extract-plugin
module.exports = {"split":"splitter_split__AoRCq"};